import { parseBoolean } from '@gitlab/frontend-utils';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import { convertObjectPropsToCamelCase } from '~/lib/utils/common_utils';
import { pinia } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/pinia/instance.js?vue3';
import CommitFormModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/projects/commit/components/form_modal.vue?vue3';
import {
  I18N_MODAL,
  I18N_CHERRY_PICK_MODAL,
  OPEN_CHERRY_PICK_MODAL,
  CHERRY_PICK_MODAL_ID,
} from './constants';
import { useCherryPickCommit } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/projects/commit/store/cherry_pick_commit.js?vue3';

export default function initInviteMembersModal(primaryActionEventName) {
  const el = document.querySelector('.js-cherry-pick-commit-modal');
  if (!el) {
    return false;
  }

  const {
    title,
    endpoint,
    branch,
    targetProjectId,
    targetProjectName,
    pushCode,
    branchCollaboration,
    existingBranch,
    branchesEndpoint,
    projects,
  } = el.dataset;

  const modalStore = useCherryPickCommit(pinia);
  modalStore.$patch({
    endpoint,
    branchesEndpoint,
    branch,
    targetProjectId,
    targetProjectName,
    pushCode: parseBoolean(pushCode),
    branchCollaboration: parseBoolean(branchCollaboration),
    defaultBranch: branch,
    modalTitle: title,
    existingBranch,
    projects: convertObjectPropsToCamelCase(JSON.parse(projects), { deep: true }),
  });

  return initVueApp({
    el,
    name: 'CommitFormModalRoot',
    pinia,
    provide: {
      modalStore,
    },
    component: CommitFormModal,
    props: {
      i18n: { ...I18N_CHERRY_PICK_MODAL, ...I18N_MODAL },
      openModal: OPEN_CHERRY_PICK_MODAL,
      modalId: CHERRY_PICK_MODAL_ID,
      isCherryPick: true,
      primaryActionEventName,
    },
  });
}
